// Fix for clicks on active page navigation, blocked by angular
$('.c-page-navigation').on('click', '.is-active a', function () {
    window.location = $(this).attr('href');
});